import { useEffect, useContext } from 'react';
import configurationService from '../services/configuration.js'
import { GeneralContext } from '../context/GeneralContext'

export const useConfiguration = () => {
    const { configuration, setConfiguration } = useContext(GeneralContext);

    useEffect(() => {
        if (configuration == null) {
            configurationService.getAll().then(data => {
                setConfiguration(data);
            });
        }
    }, []);


    return { configuration };
}